import httpClient from '@/http-client'

export default {
  login(formData) {
    return httpClient
      .post('/api/login', formData)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error.response.data))
  },
  companryLogo() {
    return httpClient
      .get('/api/get-company-logos')
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error.response.data))
  }
}
